import { Component, Input } from '@angular/core';

@Component({
  selector: 'pty-customer-cheque-account',
  templateUrl: './customer-cheque-account.component.html',
  styleUrls: ['./customer-cheque-account.component.scss']
})
export class CustomerChequeAccountComponent {
  @Input() partyId:string;
}
